import Home from "./home";
import Login from "./login";
import Register from "./signup";
import Property from "./property";
import Propertydetails from "./propertydetails";

import Payment from "./payment";

import AdminLogin from "./adminLogin";
import RRoomsUsers from "./users/rroomUsers";
import PropertyCategory from "./propertyCategory";
import RoomCategory from "./roomCategory";
import PropertyUsers from "./users/propertyUsers";
import Amenities from "./amenities";
import Customer from "./users/customer";
import CustomerEnquiry from "./Enquiry/Customer";
import CreateInventory from "./inventory";
import CheckInventory from "./inventoryCheck"
import CreateInventorySupplier from "./inventorySupplier";
import CreateInventoryItem from "./inventoryItem";
import InventoryCategory from "./inventoryCategory";
import FoodCategory from "./foodCategory";
import FoodsItems from "./foodItems";
import FoodsOrders from "./foodOrders";
import CouponPage from "./coupon";
import CustomerReviews from "./customerReviews";
import TaxSettings from "./taxSettings";
import RoomPriceSetting from "./roomPriceSetting/RoomPriceProperty";
import RoomRateManager from "./roomRateManager";
import RoomPrice from "./roomPriceSetting";
import MenuCard from "./menuCard";
import MenuCategory from "./menucategory";
import LaundryProvider from "./laundryProvider";
import LaundryService from "./laundryService";
import Laundry from "./laundry";
import UserLogins from "./users/userLogins";
import SearchResult from "./SearchResults";
import Invoice from "./Invoice";
import CancellationRefundPolicy from "./cancellationRefundPolicy";
import BreakFast from "./breakfast";
import FoodInvoice from "./foodinvoice";
import NcTypeSetting from "./nctypesetting";
import BookingReport from "./bookingReport/BookingReport";
import RoomOccupancyReport from "./bookingReport/RoomOccupancyReport";
import RevenuesReport from "./bookingReport/RevenuesReport";
import MealPlanReport from "./bookingReport/MealPlanReport";
import ExpensesReport from "./bookingReport/ExpensesReport";
import GuestReport from "./bookingReport/GuestReport";
import PaymentReport from "./bookingReport/PaymentReport";
import ManageRoles from "./manageroles";
import FoodReport from "./bookingReport/FoodReport";
import FoodPaymentReport from "./bookingReport/FoodPaymentReport";
import NewTransactionReport from "./bookingReport/NewTransactionReport";
import FoodItemsReport from "./bookingReport/FoodItemsReport";
import CityLocality from "./cityLocality/CityLocality";
import ExpensesCategory from "./expensesCategory";
import SeoUpdate from "./seoUpdate";
import HotelSummery from "./HotelFinance/Summary";
import InventoryReport from "./bookingReport/inventoryReport";
import InvoiceDownload from "./HotelFinance/InvoiceDownload";
import Sale from "./HotelFinance/Sale";
import InvoiceFinance from "./HotelFinance/InvoiceFinance";
import InvoicePayment from "./HotelFinance/InvoicePayment";
import ModuleConfiguration from "./users/ModuleConfiguration";
import ResturantOrders from "./foodOrders/ResturantOrders";
import ResturantMenu from "./foodOrders/ResturantMenu";
import ResturantTable from "./foodOrders/ResturantTable";
import BunquetFunction from "./bunquet/BunquetFunction";
import BunquetBookings from "./bunquet/BunquetBookings";
import BunquetInvoice from "./bunquet/BunquetInvoice";
import BunquetPayment from "./bunquet/BunquetPayment";
import AgreementProperty from "./signup/AgreementProperty";
import GuestDetails from "./Dashboard/guests";
import BanquetMenu from "./bunquet/BanquetMenu";
import BunquetEnquiry from "./bunquet/BanquetEnquiry";
import AddBunquetBookings from "./bunquet/AddBunquetBookings";
import ModuleConfigurationAdmin from "./users/ModuleConfigurationAdmin";
import BunquetBookingDetails from "./bunquet/BunquetBookingDetails";
import Expenses from "./accounts/Expenses";
import DSRPage from "./accounts/DSRPage";
import RevenueReport from "./accounts/RevenueReport";
import TransactionReport from "./bookingReport/TransactionReport";
import RatingReport from "./bookingReport/RatingReport";
import ResturantPayment from "./foodOrders/ResturantPayment";
import PropertyInquery from "./propertyInquery";
import Unauthorized from "./unauthorized";
import KotLogs from './foodOrders/KotLogs'
import PropertyLogs from './logs/PropertyLogs'
import TAEnquiries from './ta-enquiries'
import TaLedgerReport from './TaLedgerReport'

export default {
  Home,
  Login,
  Register,
  Property,
  Propertydetails,
  Payment,
  AdminLogin,
  RRoomsUsers,
  PropertyCategory,
  RoomCategory,
  PropertyUsers,
  Amenities,
  Customer,
  CustomerEnquiry,
  CreateInventory,
  CheckInventory,
  CreateInventorySupplier,
  CreateInventoryItem,
  InventoryCategory,
  FoodCategory,
  FoodsItems,
  FoodsOrders,
  CouponPage,
  CustomerReviews,
  TaxSettings,
  RoomPriceSetting,
  RoomRateManager,
  MenuCard,
  LaundryProvider,
  LaundryService,
  Laundry,
  UserLogins,
  SearchResult,
  Invoice,
  RoomPrice,
  CancellationRefundPolicy,
  MenuCategory,
  BreakFast,
  FoodInvoice,
  NcTypeSetting,
  BookingReport,
  RoomOccupancyReport,
  RevenuesReport,
  MealPlanReport,
  ExpensesReport,
  GuestReport,
  TransactionReport,
  RatingReport,
  PaymentReport,
  ManageRoles,
  FoodReport,
  FoodPaymentReport,
  NewTransactionReport,
  FoodItemsReport,
  CityLocality,
  ExpensesCategory,
  SeoUpdate,
  HotelSummery,
  InventoryReport,
  InvoiceDownload,
  Sale,
  InvoiceFinance,
  InvoicePayment,
  ModuleConfiguration,
  ResturantOrders,
  ResturantMenu,
  ResturantTable,
  BunquetFunction,
  BunquetBookings,
  BunquetInvoice,
  BunquetPayment,
  AgreementProperty,
  GuestDetails,
  BanquetMenu,
  BunquetEnquiry,
  AddBunquetBookings,
  ModuleConfigurationAdmin,
  BunquetBookingDetails,
  Expenses,
  DSRPage,
  RevenueReport,
  ResturantPayment,
  PropertyInquery,
  Unauthorized,
  KotLogs,
  PropertyLogs,
  TAEnquiries,
  TaLedgerReport
};
